import { createAsyncThunk } from "@reduxjs/toolkit";
import { USERAXIOS } from "api";
import responseError from "utils/api/error-handling";
import topCompanyURL from "../../../../utils/url/ads/topCompany";

//get AllUser
export const getAllTopCompany = createAsyncThunk(
  "ads/getAllTopCompany",
  async ({ pageNumber }: { pageNumber: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.get(
        `${topCompanyURL.GET_VIP_COMPANY}?page=${pageNumber}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
//GET ONE USER

export const getOneTopCompany = createAsyncThunk(
  "ads/getOneTopCompany",
  async ({ id }: { id: string }, thunkAPI) => {
    try {
      const response = await USERAXIOS.get(
        `${topCompanyURL.GE_ONE_VIP_COPMANY}${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

//EDIT ONE USER

export const editTopCompany = createAsyncThunk(
  "ads/editTopCompany",
  async ({ id, data }: { id: number; data: any }, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(
        `${topCompanyURL.EDIT_VIP_COMPANY}${id}`,
        data,
      );
      return response.data.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
export const addTopCompany = createAsyncThunk(
  "ads/addTopCompany",
  async (data: any, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(
        topCompanyURL.GET_VIP_COMPANY,
        data,
      );

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const deleteTopCompany = createAsyncThunk(
  "ads/deleteTopCompany",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.delete(
        `${topCompanyURL.DELETE_VIP_COMPANY}${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const activeTopCompany = createAsyncThunk(
  "ads/activeTopCompany",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(
        `${topCompanyURL.ACIVATE_VIP_COMPNY}${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const deactivateTopCompany = createAsyncThunk(
  "ads/deactivateTopCompany",
  async ({ id }: { id: number }, thunkAPI) => {
    try {
      const response = await USERAXIOS.post(
        `${topCompanyURL.DEACTIVATE_VIP_COMPANY}${id}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);

export const MultiDeletTopCompany = createAsyncThunk(
  "ads/MultiDeletTopCompany",
  async ({ ids }: { ids: number[] }, thunkAPI) => {
    try {
      const response = await USERAXIOS.delete(
        topCompanyURL.MULTI_DELET_VIP_COMPANY,
        {
          data: { ids },
        },
      );
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(responseError(error));
    }
  },
);
